import { useMantineTheme } from '@mantine/core';
import { IconCircle, IconCircleCheck } from '@tabler/icons-react';

interface CheckedColumnProps {
  checked: boolean;
}

export const CheckedColumn = ({ checked }: CheckedColumnProps) => {
  const theme = useMantineTheme();
  const IconComponent = checked ? IconCircleCheck : IconCircle;

  return <IconComponent color={theme.colors[theme.primaryColor][6]} opacity={checked ? 1 : 0.5} />;
};
